<template>
  <div>
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header> 

    <el-main v-loading.fullscreen.lock="loading">      
      <el-form :model="form" ref="form" label-width="180px" >
        <CustomerSearch v-if="!isCustomer" v-model="custSapCode" @sync-select-customer="syncSelectCustomer" />
       
       
       
        <el-tabs v-model="activeName" @tab-click="tabClick">
          <el-tab-pane :label="$t('field.swfw')" name="first">

            <div class="fwArea" >
              <div class="container" >
                <div class="initial">
                  <img src="..//..//assets/firmware.png" style="height:30px;width:30px "/>
                </div>
                <div class="flex">
                  <span class="typeTitle">Firmware List</span>
                </div>
              </div>

              <el-tree :data="fwData" :props="defaultProps" :highlight-current="true" :empty-text="$t('msg.noDataFound')" >
              <span slot-scope="{ node, data }" >
                <span v-if="data.children != null" class="custom-tree-node">
                  {{ data.label }}
                </span>  
                <span v-else class="custom-tree-node">
                  <el-link type="primary" @click="handleNodeClick(data)">{{ data.label }}</el-link>
                  {{'\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0' }}　　
                  <el-link type="danger"  v-if="data.import ==true"  @click="linkAction(data)" >{{$t('msg.MajorUpdStatement')}}
                   
                  </el-link>
                </span>
                <img src="..//..//assets/new_icon.gif"  class="custom-new-icon" v-if="data.new ==true" />      

              </span>
            </el-tree>
            </div>
            <br>
            <div class="swArea" >
              <div class="container" >
                <div class="initial">
                  <img src="..//..//assets/software.png" style="height:30px;width:30px "/>
                </div>
                <div class="flex">
                  <span class="typeTitle">Software List</span>
                </div>
              </div>
        
              <el-tree :data="swData" :props="defaultProps"  :highlight-current="true" :empty-text="$t('msg.noDataFound')">
                <span slot-scope="{ node, data }" >
                  <span v-if="data.children != null" class="custom-tree-node">
                    {{ data.label }}
                  </span>  
                  <span v-else class="custom-tree-node">
                    <el-link type="primary"  @click="handleNodeClick(data)" :disabled="data.import == true && data.announceTime ==null">{{ data.label }}</el-link>
                    {{'\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0' }}　　　　　
                    <el-link type="danger"  v-if="data.import==true"  @click="linkAction(data)" >{{$t('msg.MajorUpdStatement')}}       
                    </el-link>
              

                  </span>
                  <img src="..//..//assets/new_icon.gif"  class="custom-new-icon" v-if="data.new ==true" />      

                </span>
              </el-tree>
            </div>
            <br>
            <div class="updArea" >
              <div class="container" >
                <div class="initial">
                  <img src="..//..//assets/updated.png" style="height:28px;width:28px "/>
                </div>
                <div class="flex">
                  <span class="typeTitle">Update Package List</span>
                </div>
              </div>
                     
              <el-tree :data="packageData" :props="defaultProps"  :highlight-current="true" :empty-text="$t('msg.noDataFound')">
                <span slot-scope="{ node, data }" >
                  <span v-if="data.children != null" class="custom-tree-node">
                    {{ data.label }}
                  </span>  
                  <span v-else class="custom-tree-node">
                    <el-link type="primary" @click="handleNodeClick(data)">{{ data.label }}</el-link>
                    {{'\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0' }}　　
                    <el-link type="danger"  v-if="data.import ==true"  @click="linkAction(data)" >{{$t('msg.MajorUpdStatement')}}  </el-link>
                  </span>
                  <img src="..//..//assets/new_icon.gif"  class="custom-new-icon" v-if="data.new ==true" />      

                </span>
              </el-tree>
            </div>
            <br>
            <div class="kaArea" >
              <div class="container" >
                <div class="initial">
                  <img src="..//..//assets/ka.png" style="height:28px;width:28px "/>
                </div>
                <div class="flex">
                  <span class="typeTitle">KA List</span>
                </div>
              </div>
                     
              <el-tree :data="kaData" :props="defaultProps"  :highlight-current="true" :empty-text="$t('msg.noDataFound')">
                <span slot-scope="{ node, data }" >
                  <span v-if="data.children != null" class="custom-tree-node">
                    {{ data.label }}
                  </span>  
                  <span v-else class="custom-tree-node">
                    <el-link type="primary" @click="handleNodeClick(data)">{{ data.label }}</el-link>
                    {{'\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0' }}　　
                    <el-link type="danger"  v-if="data.import ==true"  @click="linkAction(data)" >{{$t('msg.MajorUpdStatement')}}  </el-link>
                  </span>
                  <img src="..//..//assets/new_icon.gif"  class="custom-new-icon" v-if="data.new ==true" />      

                </span>
              </el-tree>
            </div>
          <el-dialog ref="announceDialog" :title="dialogTitle" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">      
            <el-row>
              <el-col :span="1" style="vertical-align: top;"> 
                <el-checkbox v-model="announce1" :disabled="dialogOnlyAuth"></el-checkbox>
              </el-col>
              <el-col :span="22" style="vertical-align: top;"> 
                關於此更新的驗證已完成。<br>
                  The verifivation and validation has been done to ensure the function of this update.
              </el-col>
            </el-row>
             <br>
            <el-row>
              <el-col :span="1" style="vertical-align: top;"> 
                <el-checkbox v-model="announce2" :disabled="dialogOnlyAuth"></el-checkbox>
              </el-col>
              <el-col :span="22" style="vertical-align: top;"> 
                已確認套用此更新至所有產品，並充分被告知若此重大更新並未按照正確程序完成會有意想不到的錯誤或失效發生。<br>
                  The update has been implented to all the product according to the introduction that InnoCare provided
                  We are fully informed the update is crucial, upexpected error or malfunction will occur if the update is not finished in a proper manner.
              </el-col>
            </el-row>
            <br>
            <el-row v-if="dialogOnlyAuth">
              <el-col :span="11" > 
                <el-form-item label="簽署人" label-width="110px">
                  <el-input :disabled="true" v-model="userName" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11" > 
               <el-form-item label="簽署時間" label-width="110px">
                  <el-input :disabled="true" v-model="announceTime" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>      
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" >{{$t('button.cancel')}}</el-button>
                <el-button type="warning" @click="sendAnnounce" v-if="!dialogOnlyAuth">{{$t('button.confirm')}}</el-button>
            </span>
          </el-dialog>

          </el-tab-pane>
          <el-tab-pane :label="$t('field.document')" name="second">
            <h3>{{$t('field.differentModel')}}</h3>
            <ul>
              <li v-for="item in docModelData" :key="item.id" style="line-height: 30px;"><el-link type="primary"  @click="handleDocClick(item)" >{{ item.docName }}</el-link></li>
            </ul>
            <h3>HumanDROC</h3>
            <ul>
              <li v-for="item in docHumanData" :key="item.id" style="line-height: 30px;"><el-link type="primary"  @click="handleDocClick(item)" >{{ item.docName }}</el-link></li>
            </ul>
            <h3>VetDROC</h3>
            <ul>
              <li v-for="item in docVetData" :key="item.id" style="line-height: 30px;"><el-link type="primary"  @click="handleDocClick(item)" >{{ item.docName }}</el-link></li>
            </ul>
            <h3>KA List</h3>
            <ul>
              <li v-for="item in docKaData" :key="item.id" style="line-height: 30px;"><el-link type="primary"  @click="handleDocClick(item)" >{{ item.docName }}</el-link></li>
            </ul>
            <h3>Others</h3>
            <ul>
              <li v-for="item in docOtherData" :key="item.id" style="line-height: 30px;"><el-link type="primary"  @click="handleDocClick(item)" >{{ item.docName }}</el-link></li>
            </ul>
          </el-tab-pane>
        </el-tabs>
      </el-form>


    

    </el-main>
    
  </div>
  
</template>

<script>
import Breadcrumb from '../components/Breadcrumb.vue'
import CustomerSearch from "../components/CustomerSearch";
import { apiFindSw, apiFindFw, apiFindPackage, apiFindKa, apiFindDoc, apiGetAttachById, apiSaveSwfwAnnounce } from "../../utils/api.js";
import authHeader from "../../services/auth-header";
import AWSUtil from "../../utils/AWSUtil";


export default {
  name: 'installedSwFwList',
  data() {   
    return {   
      sortColumn:'',
      sortType:'',
      loading:false,  
      custSapCode:'', 
      activeName: 'first',  
      content: this.$i18n.t('menu.installedSwFwList'),
      isCustomer:false,
      dialogTitle:'',
      dialogVisible:false,
      announce1:false,
      announce2:false,
      swfwId:'',
      announceTime:'',
      userName:'',
      dialogOnlyAuth:false,
      form:{

      },
      fwData: [],
      swData: [],
      packageData: [],
      kaData: [],
      docData: [],
      docModelData:[],
      docHumanData:[],
      docVetData:[],
      docKaData:[],
      docOtherData:[],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    };
  },   
  components: {
    Breadcrumb,
    CustomerSearch
  },
  created(){
    this.isCustomer = this.$store.state.auth.user.username.indexOf('@')>-1 ? true : false;      
  },
  mounted() {
    this.findSwfw();    
  },
  methods: {
    findSwfw(){
      this.loading = true;
      apiFindSw({ headers: authHeader(), condition: this.custSapCode }).then((response) => {
   debugger
        this.swData = response.data;  
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        console.log(err);
      });

      apiFindFw({ headers: authHeader(), condition:this.custSapCode }).then((response) => {

        this.fwData = response.data;  
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        console.log(err);
      });

      apiFindPackage({ headers: authHeader(), condition:this.custSapCode }).then((response) => {
        this.packageData = response.data;  
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        console.log(err);
      });
      apiFindKa({ headers: authHeader(), condition:this.custSapCode }).then((response) => {
        this.kaData = response.data;  
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        console.log(err);
      });
      apiFindDoc({ headers: authHeader(), condition:this.custSapCode }).then((response) => {

        this.docData = response.data; 
        this.docModelData=[];
        this.docHumanData=[];
        this.docVetData=[];
        this.docKaData=[];
        this.docOtherData=[]; 
        response.data.forEach((item, index) => {
          
          if(item.modelRel == 'Y'){
            this.docModelData.push(item);
          }else{
            if(item.name.startsWith('Human')){
              this.docHumanData.push(item);
            }else if(item.name.startsWith('Vet')){
              this.docVetData.push(item);
            }else if(item.name.startsWith('KA')){
              this.docKaData.push(item);
            }else{
              this.docOtherData.push(item);
            }

          }  
        });

        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        console.log(err);
      });

    },
    tabClick(){

    },
    syncSelectCustomer(custNo){            
      this.custSapCode = custNo;
      this.findSwfw(this.custSapCode);
    },
    handleNodeClick(data) {       

      apiGetAttachById({ headers: authHeader(), id:data.attachId }).then((response) => {
        AWSUtil.downloadDocNoDocId(response.data.uploadType, response.data.subFolder, response.data.fileName, response.data.id );
      }).catch((err) => {
        this.loading = false;
        console.log(err);
      });
    },
    handleDocClick(data){
      apiGetAttachById({ headers: authHeader(), id:data.attachId }).then((response) => {
        AWSUtil.downloadDocNoDocId(response.data.uploadType, response.data.subFolder, response.data.fileName, response.data.id)
      }).catch((err) => {
        this.loading = false;
        console.log(err);
      });
    },
    linkAction(data){
 
      this.announceTime = data.announceTime;
      this.userName= data.userName;
      if(this.announceTime  != null){
        this.announce1 = true;
        this.announce2 = true;
        this.dialogOnlyAuth = true;
      }else{
        this.announce1 = false;
        this.announce2 = false;
        this.dialogOnlyAuth = false;
      }
      this.dialogTitle = data.label + this.$i18n.t('msg.majorUpdStatement');
      this.dialogVisible = true;
      this.swfwId = data.id;
    },
    handleClose(done) {
      this.$confirm(this.$i18n.t('msg.confirmtoClose'),{
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      }).then(_ => {             
        done();
      }).catch(_ => {});
    },
    sendAnnounce(){
      
      if(this.announce1 == false || this.announce2 == false){
        return this.$message.warning({message: this.$i18n.t('msg.incompleteInfo'), duration: 1000});
      } else {

        apiSaveSwfwAnnounce({ headers: authHeader(), condition : this.swfwId}).then((response) => {
          if(response.data == true){
            this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 1000});  
            this.dialogVisible = false;
            this.findSwfw();    
          }else{
            this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 1000}); 
            this.dialogVisible = false;  
          }  
        }).catch((err) => {
          console.log(err);
        }); 
      }
    },
    
  },
  
};
</script>

<style scoped>
.custom-tree-node {
  height: 50px;
}

.custom-new-icon{
  width: 30px; 
  position: absolute; 
}

.fwArea {
  background:#b7e8de8c;
  padding-right: 5px;
  overflow: auto; 
  padding-left: 10px;
  padding-bottom: 10px;
  padding-top: 5px;
}

.swArea {
  background:#d7e4bd8c;
  padding-right: 5px;
  overflow: auto; 
  padding-left: 10px;
  padding-bottom: 10px;
  padding-top: 5px;
}

.updArea {
  background:	#FCD5B5a8;
  padding-right: 5px;
  overflow: auto; 
  padding-left: 10px;
  padding-bottom: 10px;
  padding-top: 5px;
}

.kaArea {
  background:	#ffeb3b5c;
  padding-right: 5px;
  overflow: auto; 
  padding-left: 10px;
  padding-bottom: 10px;
  padding-top: 5px;
}

.container {
  display: -webkit-flex;
  display: flex;
  height:50px
}
.initial {
  -webkit-flex: initial;
          flex: initial;
  width: 35px;
  line-height : 40px;
  height:100%;
}
.flex {
  -webkit-flex: 2;
          flex: 2;
  height:100%
}
.typeTitle{
  font-size: 20px;
  font-weight: bold;
  line-height: 50px;
}

div img {
  vertical-align : middle;
}
div span {
  vertical-align : middle;
}
</style>